import type { CheckoutSession } from "@/types";
import { trackSessionEvent } from "./analytics-helpers";

/** Mirrors checkout `TRACKING_EVENTS` payment overdues event names. */
export type OverduePaymentsEventType =
  | "payment_overdues__page_viewed"
  | "payment_overdues__settle_pay_button_clicked"
  | "payment_overdues__payment_option_list_add_new_card_clicked"
  | "payment_overdues__add_new_card_input_number_interacted"
  | "payment_overdues__add_new_card_input_expiry_date_interacted"
  | "payment_overdues__add_new_card_input_cvv_interacted"
  | "payment_overdues__add_new_card_popup_hide_clicked"
  | "payment_overdues__payment_option_list_existing_card_clicked"
  | "payment_overdues__payment_option_list_apple_pay_clicked"
  | "payment_overdues__process_initiated"
  | "payment_overdues__process_successful"
  | "payment_overdues__process_failed";

export function emitOverduePaymentsTracking(
  eventType: OverduePaymentsEventType,
  session: CheckoutSession,
  eventData: Record<string, unknown> = {},
): void {
  trackSessionEvent(eventType, session, eventData);
}

export function overduePaymentsTotalPayload(
  session: CheckoutSession,
): Record<string, unknown> {
  const total = session.overduePayments?.totalDueAmount?.amount;
  return total != null ? { overdues_total_amount: total } : {};
}
